import React, { useState, useEffect } from "react"
import $ from "jquery"
import GoogleMapReact from "google-map-react"
//import { MarkerIcon } from '@components/icon/icon';
import Marker from "./resultsmarker"
import { connectInfiniteHits } from "react-instantsearch-dom"
import {isEmpty} from "lodash"

// const MarkerContainer = ({ hits }) => hits.map((hit, i) => <Marker key={i} lat={hit._geoloc.lat} lng={hit._geoloc.lng} text={hit.objectid}/>)

// const MapHits = connectInfiniteHits(MarkerContainer)

function MapsInfiniteHits(props) {
  useEffect(() => {
    setMapenable(false)
    setTimeout(() => {
      setMapenable(true)
    }, 100)
  }, [props.hits])
  const [mapenable, setMapenable] = useState(false)

  // const [mapmarkers, setMapmarkers] = useState([]);

  const [center, setCenter] = React.useState({ lat: 51.55736, lng: -0.08859 })

  // const ptype = props.ptype

  // const update = () => {
  //   setCenter({ lat: 51.55736, lng: -0.08859 });
  // };

  // useEffect(() => {
  //   var mapmarkersarr = [];
  //   const myObserverWhenMyNodeExist = () => {
  //     //if (typeof window === "undefined" || !window.document)
  //     {
  //     var targetNode = document.getElementById('property_list_results');//document.getElementById('property_list_results');//$('#property_list_results')[0];//
  //     if(!targetNode) {
  //       //node not exist try again
  //       window.setTimeout(myObserverWhenMyNodeExist,500);
  //       return;
  //     }
  //     // Options for the observer (which mutations to observe)
  //     var config = { attributes: true, childList: true, subtree: true };

  //     // Callback function to execute when mutations are observed
  //     var callback = function(mutations, observer) {
  //       update();
  //       mapmarkersarr.length = 0;
  //       // Use traditional 'for loops' for IE 11
  //       setMapmarkers([]);
  //       $('.mysingleproperty').each(function () {
  //         if (typeof $(this).data("lat") !== "undefined") {
  //           mapmarkersarr.push({objectid: "#"+ptype+$(this).data("objectid"), lat: $(this).data("lat"), lng: $(this).data("lng") })
  //         }
  //       });
  //       //console.log(mapmarkersarr)
  //       setMapmarkers(mapmarkers => mapmarkersarr);
  //       //setMapmarkers(mapmarkersarr);
  //       //console.log(mapmarkers)
  //       setMapenable(Math.floor(Math.random() * 100) + 1);
  //     };

  //     // Create an observer instance linked to the callback function
  //     var observer = new MutationObserver(callback);

  //     // Start observing the target node for configured mutations
  //     observer.observe(targetNode, config);
  //     }
  //   }

  //   myObserverWhenMyNodeExist();
  // }, [])
  // // Return map bounds based on list of places
  // const mygetMapBounds = (map, maps, places) => {
  //   const bounds = new maps.LatLngBounds();

  //   places.forEach((place) => {
  //     bounds.extend(new maps.LatLng(
  //       place.lat,
  //       place.lng,
  //     ));
  //   });
  //   return bounds;
  // };

  // // Re-center map when resizing the window
  // const mybindResizeListener = (map, maps, bounds) => {
  //   maps.event.addDomListenerOnce(map, 'idle', () => {
  //     maps.event.addDomListener(window, 'resize', () => {
  //       // map.fitBounds(bounds);
  //     });
  //   });
  // };

  // // Fit map to its bounds after the api is loaded
  // const myapiHasLoaded = (map, maps, places) => {
  //   // Get bounds by our places
  //   const bounds = mygetMapBounds(map, maps, places);
  //   // Fit map to bounds
  //   // map.fitBounds(bounds);
  //   // Bind the resize listener
  //   mybindResizeListener(map, maps, bounds);
  // };

  return (
    <div id="map" className="map">
      {/* {props.hits[0]?._geoloc?.lat} */}
      {mapenable && (
        <GoogleMapReact
          bootstrapURLKeys={{
            key: process.env.GATSBY_MAPS_API_KEY,
            // key:""
          }}
          defaultCenter={{
            lat: props.hits[0]?._geoloc?.lat,
            lng: props.hits[0]?._geoloc?.lng,
          }}
          center={{
            lat: props.hits[0]?._geoloc?.lat,
            lng: props.hits[0]?._geoloc?.lng,
          }}
          water={false}
          zoom={13}
          yesIWantToUseGoogleMapApiInternals
        // onGoogleApiLoaded={({ map, maps }) => myapiHasLoaded(map, maps, mapmarkers)}
        >
          {/* {mapmarkers.map((pnt,ind) => 
          <Marker key={ind} lat={pnt.lat} lng={pnt.lng} text={pnt.objectid} />
        )} */}
          {props.hits.map((hit, i) => {
            if(!isEmpty(hit?._geoloc) && !isEmpty(hit?._geoloc)){
              return (
                <Marker
                  key={i}
                  lat={hit._geoloc.lat}
                  lng={hit._geoloc.lng}
                  text={hit.objectID}
                />
              )
            } 
          })}
        </GoogleMapReact>
      )}
    </div>
  )
}

export default connectInfiniteHits(MapsInfiniteHits)
